var mod = require('./dist/browser.common.js');
module.exports = mod;
module.exports.default = mod;